// extracted by mini-css-extract-plugin
module.exports = {"padding20px":"style_padding20px__1D9RD"};